import { render } from "./RecipeDetailPage.vue?vue&type=template&id=2526b118&ts=true"
import script from "./RecipeDetailPage.vue?vue&type=script&lang=ts"
export * from "./RecipeDetailPage.vue?vue&type=script&lang=ts"

import "./RecipeDetailPage.vue?vue&type=style&index=0&id=2526b118&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__